import { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';

import { HotelRoomModalTabs } from './HotelRoomModalTabs';
import { HotelType, RoomType } from '../../../../types/HotelType';

import styles from '../../../Hotels/modal.module.scss';
import { DataLayerAPI } from '../../../../api/DataLayerAPI';

type HotelRoomModalProps = {
    room: RoomType,
    hotel: HotelType
  }

const dataLayerAPI = new DataLayerAPI()

export function HotelRoomModal({ room, hotel }: HotelRoomModalProps) {

  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);

    return (
      <div className={styles.modalLinkSection}>
        <p className={styles.detailsLink}>
          <button aria-label={`room item ${room.title}`} className={styles.modalLink} onClick={() => setOpen(o => !o)}>
            Full Room Details
          </button>
        </p>
          <Popup open={open} closeOnDocumentClick modal onOpen={() => dataLayerAPI.logModalAction('Modal Opened','Hotels Index Page',hotel.title)} onClose={() => {
            dataLayerAPI.logModalAction('Modal Closed','Hotel Index Page',hotel.title);
            setOpen(false);
          }}>
            {(close: Function) => (
              <div className={styles.modal}>
                <button className={styles.close} onClick={closeModal}>
                  <span className='visuallyHidden'>Close</span>
                </button>
                <div className={styles.popupHeader}>
                </div>
                <HotelRoomModalTabs key={room.product_id} room={room} hotel={hotel}/>
                <div className={styles.popupFooter}>
                </div>
              </div>
            )}
          </Popup>
        </div>
      )
}